import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DialogRef, DialogService} from "@progress/kendo-angular-dialog";
import {
  ModalTrocarcartaoComponent
} from "../../fidelidade/assinatura-trocarcartao/modal-trocarcartao/modal-trocarcartao.component";
import {KendoPopupUtils} from "../../lib/KendoPopupUtils";

@Component({
  selector: 'app-fatura-aberta-pagar',
  templateUrl: './fatura-aberta-pagar.component.html',
  styleUrls: ['./fatura-aberta-pagar.component.scss']
})
export class FaturaAbertaPagarComponent implements OnInit {
  @Input() fatura: any = {}
  fechouAlerta = false;
  @Input() emModal = false;
  @Output() pagarComCartao = new EventEmitter<void>();
  mensagemCopiada: string;
  constructor(          private dialogService: DialogService) { }

  ngOnInit(): void {
  }

  get numeroParcelas(): number {
    if(!this.fatura.cartao) return 1;

    return Math.max(1, Number(this.fatura.parcelamentoMaximo || this.fatura.maxParcelas || 1));
  }

  get valorParcela(): number {
    return Number(this.fatura.total || 0) / this.numeroParcelas;
  }


  abraModalPagarCartao(){
    this.pagarComCartao.emit();

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: ModalTrocarcartaoComponent,
      minWidth: 250,
      width: window.innerWidth > 650 ? 650 : window.innerWidth,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef)

    //windowRef.content.instance.contrato = contrato;
    windowRef.content.instance.fatura =  this.fatura;
    windowRef.content.instance.reload =  false;
    windowRef.content.instance.exibirFechar =  true;
  }

  temImagemPix(): boolean {
    return Boolean(this.obtenhaImagemQrCodePix());
  }

  obtenhaImagemQrCodePix(): string {
    const qrcode = String(this.fatura?.pix?.qrcode || this.fatura?.pix?.qrcodeText || '');

    if(!qrcode) return null;

    if(/^(data:|https?:\/\/|\/)/i.test(qrcode))
      return qrcode;

    return `/api/qrcode?c=${encodeURIComponent(qrcode)}`;
  }

  copyMessage(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.mensagemCopiada = val;

    setTimeout( () => {
      delete this.mensagemCopiada
    }, 5000);
  }

}
